import clsx from 'clsx';
import type { ReactNode } from 'react';

/** Inner brown card — same styles as Home welcome copy block. */
export function SurveyBrownPanel({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={clsx(
        'w-full rounded-lg bg-[#754C29]/50 p-4 text-[20px] sm:text-[22px] text-white/95 leading-snug drop-shadow-sm',
        className
      )}
    >
      {children}
    </div>
  );
}

/**
 * Horizontal alignment for brown panels on **flow** pages: cancels `SurveyBackgroundLayout`’s
 * `px-6` then applies `px-9`, matching Home’s `absolute inset-x-0 … px-9` brown strip width.
 */
export function SurveyBrownPanelInset({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return <div className={clsx('-mx-6 px-9', className)}>{children}</div>;
}
